// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar__Sidebar__mBcwm"};